import { useContext } from 'react';
import { AppContext } from '../sporttia/AppContext';

/**
 * Cierre de sesión del gestor: pide confirmación, llama a `POST /logout` y, al
 * terminar, borra la sesión y la cabecera. Lo comparten el menú de usuario y la
 * pantalla de "sin acceso".
 */
export function useLogout(): () => void {
    const cxt = useContext(AppContext)!;

    return () => {
        cxt?.api('POST', '/logout', {
            confirmation: true,
            success: () => {
                cxt.setLoggedUser(false);
                cxt.setHeader(null);
            },
        });
    };
}
